import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import preciosService from '../services/preciosService';
import { preciosKeys } from '../queryKeys';

export const usePreciosCentros = (headquarter) =>
  useQuery({
    queryKey: preciosKeys.centros(headquarter),
    queryFn: async () => {
      const data = await preciosService.listarCentros({ headquarter });
      return Array.isArray(data?.centros) ? data.centros : [];
    },
    enabled: Boolean(headquarter),
    staleTime: 10 * 60 * 1000,
  });

// keepPreviousData: al teclear en el buscador o cambiar un filtro la tabla
// sigue visible con los datos anteriores mientras llega la nueva respuesta.
export const usePrecios = ({ headquarter, idcentro = '', tipo = '', search = '' }) =>
  useQuery({
    queryKey: preciosKeys.lista(headquarter, { idcentro, tipo, search }),
    queryFn: async () => {
      const data = await preciosService.listarPrecios({ headquarter, idcentro, tipo, search });
      return Array.isArray(data?.precios) ? data.precios : [];
    },
    enabled: Boolean(headquarter),
    placeholderData: keepPreviousData,
  });

export const useActualizarPrecio = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idcentro, codigocurso, cambios }) =>
      preciosService.actualizarPrecio({ headquarter, idcentro, codigocurso, cambios }),
    onSuccess: () => qc.invalidateQueries({ queryKey: preciosKeys.listas(headquarter) }),
  });
};
